import { writable } from 'svelte/store';

let skills = writable([
  {
    id: 1,
    toolName: "HTML",
    icon: "html"
  },
  {
    id: 2,
    toolName: "CSS",
    icon: "css"
  },
  {
    id: 3,
    toolName: "Javascript",
    icon: "javascript"
  },
  {
    id: 4,
    toolName: "Typescript",
    icon: "typescript"
  },
  {
    id: 5,
    toolName: "Adobe XD",
    icon: "adobe-xd"
  },
  {
    id: 6,
    toolName: "React JS",
    icon: "react"
  },
  {
    id: 7,
    toolName: "Svelte JS",
    icon: "svelte"
  },
  {
    id: 8,
    toolName: "Node JS",
    icon: "nodejs"
  },
  {
    id: 9,
    toolName: "Firebase",
    icon: "firebase"
  },
  {
    id: 10,
    toolName: "Github",
    icon: "git"
  },
  {
    id: 11,
    toolName: "Mongo DB",
    icon: "mongodb"
  },
  {
    id: 12,
    toolName: "MySQL",
    icon: "mysql"
  },
  {
    id: 13,
    toolName: "GraphQL",
    icon: "graphql"
  },
  {
    id: 14,
    toolName: "Rest APIs",
    icon: "json"
  },
  {
    id: 15,
    toolName: "Tailwind",
    icon: "tailwindcss"
  },
  {
    id: 16,
    toolName: "Post CSS",
    icon: "postcss"
  },
  {
    id: 17,
    toolName: "SCSS",
    icon: "sass"
  },
  {
    id: 18,
    toolName: "Gatsby JS",
    icon: "gatsby"
  },
  {
    id: 19,
    toolName: "Strapi JS",
    icon: "strapi"
  },
  {
    id: 20,
    toolName: "PWAs",
    icon: "pwa"
  },
  {
    id: 21,
    toolName: "C++",
    icon: "cpp"
  },
  {
    id: 22,
    toolName: "Java",
    icon: "java"
  },
  {
    id: 23,
    toolName: "Svelte Kit",
    icon: "sveltekit"
  },
]);

export default skills;